import styled from "@emotion/styled";

export const Editor = styled.div`
  grid-area: editor;
  background: white;
  flex: 1;
  overflow-y: scroll;
`;
